
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Dialog from '../Dialog';
import DialogContainer from '../DialogContainer';
import ParHistoryPanel from './ParHistoryPanel';

const classNames = mergeStyleSets({
    ParHistoryDialog: {
        padding: 16
    },
    content: {
        paddingRight: 8,
        marginBottom: 8,
        //width: 1000,
        //height: 700
    }
});

const ParHistoryDialog = ({open, onDismiss, parId}) => {

    return (
        <Dialog
            open={open}
            onDismiss={onDismiss}
            title="Historie parcely"
        >
            <Stack className={classNames.ParHistoryDialog}>
                <Stack.Item className={classNames.content}>
                    <ParHistoryPanel parId={parId} />
                </Stack.Item>
            </Stack>
        </Dialog>
    );
}

class ParHistoryDialogContainer extends DialogContainer {
    static resolve = null;
    static instance = null;

    static create() {
        ParHistoryDialogContainer.instance = DialogContainer.create(
            ParHistoryDialogContainer.instance,
            ParHistoryDialogContainer
        );
        return ParHistoryDialogContainer.instance;
    }

    constructor(props) {
        super(props, {parId: null});
    }

    getResolve() {
        return ParHistoryDialogContainer.resolve;
    }

    open(parId) {
        return super.open({parId});
    }

    renderContent() {
        let props = {
            parId: this.state.parId,
            ...this.getDialogProps()
        }
        return (
            <ParHistoryDialog
                {...props}
            />
        );
    }

    setResolve(res) {
        ParHistoryDialogContainer.resolve = res;
    }
}

export default ParHistoryDialogContainer.create;
